import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
  Sun as SunIcon,
  Moon as MoonIcon,
  Globe as GlobeIcon,
  LogOut as LogoutIcon,
  Settings as SettingsIcon,
} from 'react-feather'
import { Divider, Menu, Switch } from 'antd'
import type { MenuProps } from 'antd/es/menu'

import { FlexRow } from '../FlexboxReusables/FlexItems'
import { availableLocales } from '../../i18n/locales'
import { LanguageContext } from '../../i18n/LanguageContext'
import { ThemeContext } from '../../Theme/ThemeContext'
import { AuthContext } from '../Auth/AuthContext'
import { UserContext } from '../User/UserContext'
import { UserRole } from '../User/types'

type MenuItem = Required<MenuProps>['items'][number]

const UserMenu: React.FC = () => {
  const { setLanguage } = useContext(LanguageContext)
  const { isDarkMode, setDarkMode } = useContext(ThemeContext)
  const { userDetails } = useContext(UserContext)
  const { authUser, logout } = useContext(AuthContext)
  const role = authUser.role.toLowerCase() as UserRole
  
  const handleLanguageChange = (languageCode: string) => {
    const validLanguageCodes = availableLocales.map((locale) => locale.languageCode)

    if (validLanguageCodes.includes(languageCode)) {   
      setLanguage(languageCode)
    }
  }

  const getItem = (
    label: React.ReactNode,
    key?: React.Key | null,
    icon?: React.ReactNode,
    children?: MenuItem[],
  ): MenuItem => ({ label, key, icon, children } as MenuItem)

  const items: MenuItem[] = [
    getItem(
      // Main Heading
      <FormattedMessage description='language' id='generic.language' />, 'sub1', <GlobeIcon size={16}/>, 
      // automatically generate sub-menu items from available locales
      availableLocales.map((locale) => (
        getItem(
          <FormattedMessage description={locale.languageName.props.description} id={locale.languageName.props.id} />,
          `${locale.languageCode}`,
          <span style={{marginTop: '2px'}}>
            {locale.icon}
          </span>,
        )
      ))),
    getItem(
      role !== UserRole.CLIENT
        ? (
          <Link to='/user-settings'>
            <FormattedMessage description='language' id='generic.settings' />
          </Link>
        )
        : (
          <Link to='/client-settings'>
            <FormattedMessage description='language' id='generic.settings' />
          </Link>
        ),
      'link1',
      <SettingsIcon size={16} />,
    ),
    getItem(
      <div onClick={() => logout()} style={{display: 'flex', alignItems: 'center'}}>
        <LogoutIcon size={16} style={{marginRight: '0.5em'}}/>
        <FormattedMessage description='logout' id='generic.logout' />
      </div>,
      'link2',
    )
  ]

  return (
    <>
      <FlexRow>
        <FormattedMessage
          description='hello'
          id='generic.hello'
        />, {userDetails.firstName} {userDetails.lastName}
      </FlexRow>
      <Divider type="horizontal" style={{margin: '5px'}}/>
      <FlexRow>
        <FlexRow>
          <SunIcon size={16}/>
          <Switch
            checked={isDarkMode}
            onChange={(value) => setDarkMode(value ? true : false)}
            style={{margin: '0 7px'}}
          />
          <MoonIcon size={16}/>
        </FlexRow>
        <Divider type="vertical" />
        <FlexRow>
          {isDarkMode ? 'Dark' : 'Light'}
        </FlexRow>
      </FlexRow>
      <Divider type="horizontal" style={{margin: '5px'}}/>
      <Menu
        style={{ width: 256 }}
        defaultSelectedKeys={[ '1' ]}
        mode={'inline'}
        items={items}
        onClick={({ key }) => handleLanguageChange(key)}
      />
    </>
  )
}

export default injectIntl(UserMenu)